module.exports = __webpack_public_path__ + "img/3x.bebd9c7.jpg";